<template>
  <section class="view">
    <div class="container center-page-content py-4">
      <template v-if="cameraPermissionDenied">
        <div class="row align-items-center justify-content-center checkin-error">
          <div class="col text-center">
            <EnableCam/>
          </div>
        </div>
      </template>
      <template v-else-if="serverError">
        <div class="row align-items-center justify-content-center checkin-error">
          <div class="col text-center">
            <Icon name="grAlertTriangle" width="36" class="mb-3"/>
            <div class="mb-4">
              <h1 class="title mb-2">{{ $t('pages.checkins.error_title') }}</h1>
              <h4 class="subtitle">
                {{ $t('pages.checkins.error_subtitle') }}
              </h4>
            </div>
            <b-button variant="primary" @click="retryCheckin">
              {{ $t('pages.checkins.error_retry_button') }}
            </b-button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row align-items-center justify-content-center checkin-error">
          <div class="col text-center">
            <Icon name="grFaceFrown" width="36" class="mb-3"/>
            <div class="mb-4">
              <h1 class="title mb-2">{{ $t('pages.checkins.error_title') }}</h1>
              <h4 class="subtitle">
                {{ $t('pages.checkins.error_subtitle') }}
              </h4>
            </div>
            <b-button variant="primary" :href="contactUrl" target="_blank">
              {{ $t('pages.checkins.contact_us') }}
            </b-button>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>

import {getContactUrl} from "@/utils";
import {mapActions, mapGetters} from "vuex";
import {checkinErrors} from "@/consts";
import EnableCam from "@/domain/checkin/components/EnableCam.vue";


export default {
  name: 'CheckinError',
  components: {EnableCam},
  async mounted() {
    if (this.error) {
      this.$sentry.captureMessage(this.error, {
        extra: {
          picacode: this.picacode,
          data: this.data,
          route: this.$route.name,
        },
        user: {
          id: this.currentUser.id,
          email: this.currentUser.email,
        },
        tags: {
          errorType: this.error,
          location: 'CheckinError'
        },
        level: 'error'
      })

      if (this.error === checkinErrors.CAMERA_PERMISSION_DENIED) {
        const autoRetryCheckin = sessionStorage.getItem('auto-retry-checkin');
        if (autoRetryCheckin) {
          sessionStorage.removeItem('auto-retry-checkin')
          await this.retryCheckin()
        } else {
          sessionStorage.setItem('auto-retry-checkin', true)
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', [
      'currentUser',
    ]),
    error() {
      return this.$route.query.error
    },
    picacode() {
      return this.$route.query.picacode
    },
    data() {
      return this.$route.query.data || ''
    },
    contactUrl() {
      return getContactUrl()
    },
    cameraPermissionDenied() {
      return this.error === checkinErrors.CAMERA_PERMISSION_DENIED && this.picacode !== undefined
    },
    serverError() {
      return this.error === checkinErrors.SERVER_ERROR && this.picacode !== undefined
    }
  },
  methods: {
    ...mapActions('checkin', [
      'createCheckin',
      'openStepModal',
    ]),
    async retryCheckin() {
      sessionStorage.setItem('picacode', this.picacode)
      await this.$router.push({name: 'checkins-list'})
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('checkin_form_data')
  }
}
</script>
<style>
.site-banner {
  display: none !important;
}
</style>